import ModalContato from "..";
import { formatPhoneNumber } from "../../../../../utility/phoneFunctions";
import { Mail, MessageCircle, Phone, Smartphone} from "lucide-react";
import { Divider } from "../../../../Ui/ProfileMenu/styles";
import { useAuth } from "../../../../../contexts/UserContext";
import { BotaoBranco } from "../../styles";

export default function ModalContatoProfissional({
    profissional,
    modalAtivo,
    setModalAtivo
}: {
    profissional: any,
    modalAtivo: boolean,
    setModalAtivo: (modalAtivo: boolean) => void
}) {
    const {user} = useAuth();
    return (
        <ModalContato
            modalAtivo={modalAtivo}
            setModalAtivo={setModalAtivo}
        >
            <div className="contact-item">
                <Mail />
                {profissional?.email}
            </div>
            <div className="contact-item">
                <Smartphone />
                {formatPhoneNumber(profissional?.celular)}
            </div>
            <div className="contact-item">
                <MessageCircle />
                {formatPhoneNumber(profissional?.whatsapp)}
            </div>
            <div className="contact-item">
                <Phone />
                {profissional?.tel_fixo ? formatPhoneNumber(profissional?.tel_fixo) : 'Telefone não disponível'}
            </div>
            <div className="contact-item">
                <Phone />
                {profissional?.tel_recado ? formatPhoneNumber(profissional?.tel_recado) : 'Telefone de recado não disponível'}
            </div>
            {user.profile !== 'comum' && user.profile !== 'Solicitante' && (
                <>
                <Divider />
                <BotaoBranco onClick={() => window.open(`/profissionais/${profissional?.id_usuario}`, '_blank')}>Acessar perfil</BotaoBranco>
                </>
            )}
        </ModalContato>
    )
}